<template>
  <section class="no_car_list">
    <img src="../../stylesheets/images/icon/no-vehicwle-icon.jpg" class="no_car_icon" />
    <p class="tips">{{title}}</p>
    <slot></slot>
  </section>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '暂无车辆'
    }
  },
  data() {
    return {}
  },
  methods: {}
}

</script>
<style scoped lang="less">
@w2: 75rem;
.no_car_list {
  .no_car_icon {
    display: block;
    margin: 0 auto;
    padding: 250/@w2 0 50/@w2;
    width: 175/@w2;
    height: 175/@w2;
  }
  .tips {
    text-align: center;
    color: #000;
    opacity: 0.4;
    font-size: 30/@w2;
  }
}
</style>
